var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuNoplay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.828,
    height: 24.086,
    viewBox: "0 0 23.828 24.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_914",
    "data-name": "Rectangle 914",
    width: 23.709,
    height: 23.704,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3360",
    "data-name": "Group 3360",
    transform: "translate(-54.393 -878.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3359",
    "data-name": "Group 3359",
    transform: "translate(54.453 878.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2482",
    "data-name": "Group 2482",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    d: "M0,12.026A3.4,3.4,0,0,1,3.326,9.693a4.29,4.29,0,0,1,2.053.443c.136.07.161.017.156-.106,0-.061,0-.123,0-.185,0-3,0-6.008-.006-9.012A.809.809,0,0,1,6.013,0h.463a.967.967,0,0,1,.268.178A20,20,0,0,1,10.5,5.271a5.334,5.334,0,0,1,.618,2.394,3.733,3.733,0,0,1-.453,1.678A6.221,6.221,0,0,1,9.581,10.86a.721.721,0,1,1-1.05-.983,5.891,5.891,0,0,0,.944-1.391A2.4,2.4,0,0,0,9.5,6.621a10.976,10.976,0,0,0-1.555-2.8A14.978,14.978,0,0,0,6.983,2.6a.489.489,0,0,0-.028.263c0,3.122-.022,6.244.009,9.365a2.673,2.673,0,0,1-1.646,2.629,4.052,4.052,0,0,1-4.157-.267A2.767,2.767,0,0,1,0,12.951Zm3.43-.895a2.564,2.564,0,0,0-1.547.509,1.006,1.006,0,0,0-.025,1.671,2.719,2.719,0,0,0,3.188.031,1.016,1.016,0,0,0-.01-1.716,2.644,2.644,0,0,0-1.606-.495",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M130.047,75.345c0,1.888-.015,3.777.006,5.665a2.571,2.571,0,0,1-1.223,2.273,4.125,4.125,0,0,1-4.953-.334,2.423,2.423,0,0,1,.288-3.84,4.107,4.107,0,0,1,4.233-.35c.231.1.228.108.228-.147q0-2.567,0-5.133c0-.254,0-.256-.23-.158q-3.93,1.683-7.861,3.362c-.179.076-.205.189-.205.358,0,2.705-.01,5.411.01,8.116a2.615,2.615,0,0,1-.915,2.058,4.134,4.134,0,0,1-5.266-.108,2.424,2.424,0,0,1,.3-3.84,4.112,4.112,0,0,1,4.193-.364c.268.113.264.123.264-.182,0-3.021.005-6.043-.006-9.064a.839.839,0,0,1,.573-.868q4.74-2.022,9.473-4.062a.754.754,0,0,1,1.1.722c-.028,1.965-.011,3.931-.011,5.9m-1.42-4.284c0-.146,0-.293,0-.439,0-.126-.026-.175-.158-.11s-.3.128-.445.192q-3.747,1.605-7.5,3.208a.269.269,0,0,0-.2.292c.012.246,0,.493,0,.739s0,.257.23.159q3.758-1.61,7.515-3.223c.677-.292.53-.091.548-.819M126.6,82.505a2.549,2.549,0,0,0,1.545-.51,1.011,1.011,0,0,0,.008-1.688,2.724,2.724,0,0,0-3.207.016,1,1,0,0,0-.006,1.642,2.59,2.59,0,0,0,1.661.54m-9.792,1.449a2.565,2.565,0,0,0-1.553.512,1.006,1.006,0,0,0-.017,1.671,2.721,2.721,0,0,0,3.169.039,1.017,1.017,0,0,0,0-1.73,2.642,2.642,0,0,0-1.6-.492",
    transform: "translate(-106.349 -64.404)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2806",
    "data-name": "Path 2806",
    d: "M0,0,21,21",
    transform: "translate(55.808 880.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuNoplay);
export default __webpack_public_path__ + "static/media/icon_menu_noplay.086cd1cfc276978049e1b3c34cf0541b.svg";
export { ForwardRef as ReactComponent };